module.exports = __webpack_public_path__ + "img/Compact-FR-Profiles.644e516f.jpg";